import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Quasar from 'quasar/src/vue-plugin.js';
import '../src/composables/useNotification'
import quasarUserOptions from './quasar-user-options'

// ✅ Forzar actualización del SW y limpiar caché
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((sw) => {
      sw.unregister();
      console.log('SW desregistrado:', sw);
    });
  });
  caches.keys().then((cacheNames) => {
    cacheNames.forEach((cacheName) => {
      caches.delete(cacheName);
      console.log('Caché eliminado:', cacheName);
    });
  });
}

createApp(App)
    .use(Quasar, quasarUserOptions) 
    .use(store) 
    .use(router)
    .mount('#app')